import { isPlatform } from '@ionic/react';
import { FirebaseCrashlytics } from 'fpc-custom-plugin-firebase-crashlytics';

export const setEnabled = (enabled: boolean) => {
    if (isPlatform('capacitor')) {
        FirebaseCrashlytics.setEnabled({
            enabled,
        });
    }
}

export const setUserId = (userId: string) => {
    if (isPlatform('capacitor')) {
        FirebaseCrashlytics.setUserId({
            userId
        });
    }
}

export const setCrash = (message: string) => {
    if (isPlatform('capacitor')) {
        FirebaseCrashlytics.crash({
            message
        });
    }
}
/**
 * Add Crash Message
 * @param message 
 */
export const setCrashMessage = (message: string) => {
    if (isPlatform('capacitor')) {
        FirebaseCrashlytics.addLogMessage({
            message
        });
    }
}

/**
 *  Record Exception Like API Calls
 * @param data 
 */
export const recordException = (data: any) => {
    if (isPlatform('capacitor')) {
        FirebaseCrashlytics.recordException(data);
    }
}